var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMagnifying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 71,
    viewBox: "0 0 53 71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.032 .147)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.725,
    fill: "#FFF",
    cx: 39.154,
    cy: 15.545,
    r: 13.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.315 16.406s.241-.542.397-.8c.156-.256.823-1.008.937-.838.113.17.568 1.317.326 1.638-.24.32.016.88-1.185 1.217l-.475-1.217",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.977 12.982s6.144 5.128 8.54 4.654c1.873-.372 4.747-1.358 4.747-1.358l.576 1.47s-2.579 3.498-5.267 3.521c-4.201.037-7.306-1.819-7.306-1.819l-1.29-6.468",
    fill: "#6980E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.202 67.076s.179 2.877.735 2.918C1.011 70 3.76 70 3.76 70l3.51-.02s-.023-.846-1.049-1.025c-1.026-.18-2.743-.9-3.364-2.256-.654-1.426-2.655.377-2.655.377",
    fill: "#1C4B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 67.276s1.067.357 1.9.357c.929 0 1.773-.254 1.773-.254s.201-1.942 1.306-6.222c.58-2.243 1.407-5.127 2.585-8.711 3.255-9.904 4.245-15.699 4.335-16.248l.007-.043-.01-.005-10.008-4.393s1.236 13.65-.342 18.89c-.22.732-.41 1.586-.572 2.51C-.023 58.85 0 67.276 0 67.276",
    fill: "#FFA561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98 61.157c.579-2.243 1.406-5.127 2.584-8.711 3.255-9.904 4.245-15.699 4.335-16.248a.793.793 0 0 0-.004-.048L1.888 31.757s1.236 13.65-.342 18.89c-.22.732 3.433 10.51 3.433 10.51",
    fill: "#F4904D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.019 67.076s.178 2.877.735 2.918c.074.006 2.823.006 2.823.006l3.51-.02s-.024-.846-1.05-1.025c-1.025-.18-2.742-.9-3.364-2.256-.653-1.426-2.654.377-2.654.377",
    fill: "#1C4B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.693 32.078s.13 8.846-1.4 19.707c-1.531 10.862-1.013 15.472-1.013 15.472s-1.051.34-1.475.376c-1.082.088-2.19-.254-2.19-.254s-2.19-10.865-1.563-16.302c.628-5.436-3-18.654-3-18.654l10.64-.345",
    fill: "#FFA561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.597 11.377 1.953 1.28 1.78-.502c.325-.464.41-1.359.416-2.134.004-.768-.07-1.42-.07-1.42L8.04 7.436l-.983-.433c.003.015.076.808.087.923.183 2.054-.547 3.45-.547 3.45",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.738 34.538c-2.432 2.347-11.634 1.952-12.201-.634-.566-2.587.618-22.02 4.772-23.24.862-.253 5.47 1.235 5.47 1.235s.723 1.893 1.197 4.3c.092.47.36 5.435.562 10.08.093 2.173.173 4.277.213 5.817.037 1.442.039 2.39-.013 2.442",
    fill: "#8C9DF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34 7.964c.536.904 2.412 1.695 3.406 2.057.004-.768-.07-1.42-.07-1.42L8.04 7.436c-.582-.008-.937.123-.7.527",
    fill: "#FCA56B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.67 8.44S7.423 9.765 6.64 7.108c-.785-2.657-1.862-4.276.817-5.235 2.678-.957 3.506-.1 3.984.723.477.824 1.313 5.432.229 5.844",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.274 2.34s-.27 3.093-.91 2.959c-.64-.135-1.344-.422-1.25.51.094.932-.622 2.53-1.544 2.527-1.978-.009-4.126-5.083-3.585-6.045 1.562-2.777 9.547-3.338 7.29.05",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.65 10.731c-.055-.023-3.162-1.417-3.525-1.296-.364.119-.816 1.229-.816 1.229l5.47 1.236s-.43-.875-1.13-1.169",
    fill: "#6980E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.99 25.78 12.575 42.176c-.342.321-.772.423-.957.227l-.588-.624c-.185-.196-.056-.62.285-.941L28.73 24.443c.342-.322.772-.424.956-.228l.588.624c.185.197.057.62-.285.941",
    fill: "#1F4D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.217 34.982-7.641 7.194c-.342.321-.772.423-.957.227l-.588-.624c-.185-.196-.056-.62.285-.941l7.642-7.195 1.26 1.339",
    fill: "#739AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.888 6.992a12.558 12.558 0 0 1 11.31-3.772 12.511 12.511 0 0 1 6.46 3.232c5.057 4.757 5.3 12.712.542 17.769a12.516 12.516 0 0 1-6.25 3.618 12.556 12.556 0 0 1-11.52-3.076c-5.057-4.757-5.3-12.713-.542-17.77m-3.901 12.596a13.569 13.569 0 0 0 3.704 5.959c5.49 5.165 14.13 4.9 19.294-.588 5.097-5.42 4.907-13.9-.375-19.087a8.034 8.034 0 0 0-.214-.206C42.906.501 34.269.763 29.104 6.254a13.643 13.643 0 0 0-3.117 13.335",
    fill: "#1F4D84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.751 32.096C4.156 25.26 4.954 16.135 4.954 16.135c3.507 1.978 6.987 6.351 8.584 10.145.093 2.172.173 4.276.213 5.816",
    fill: "#6980E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.221 28.982c.677-.156 1.131-.667 1.226-.757 0 0 .288.02-.048.636-.027.051-.09.183-.137.276-.02.039.008.083.05.087.39.03.783-.126 1.535.032.104.02.134.27.13.376-.006.179.007.38-.202.655-.12.16-.459.332-1.212.635-.287.115-1.107.028-1.876-.236l-.615-.284.191-1.142.154.032c.245.052.549-.248.804-.31",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.932 11.9s-8.622 1.642 2.536 14.127c1.785 1.997 11.426 4.597 11.426 4.597s.978-.832.485-1.506c0 0-6.638-4.82-8.099-5.587-.657-.345-2.55-7.694-3.621-9.464-1.071-1.77-2.727-2.167-2.727-2.167",
    fill: "#8C9DF4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMagnifying);
export default __webpack_public_path__ + "static/media/userMagnifying.bba7066b3e1416fd8c040b56ec8e879e.svg";
export { ForwardRef as ReactComponent };